module.exports = __webpack_public_path__ + "assets/people.665094ec.svg";